export default __webpack_public_path__ + "static/media/016-Loki.e1c3dd64.svg";